interface BillingAlertsSectionProps {
  onAddAlert: () => void
  currentCredit: number | string
  currencySymbol?: string
}

const BillingAlertsSection = (props: BillingAlertsSectionProps) => {
  const { onAddAlert, currentCredit = 10, currencySymbol = '$' } = props

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body'>
        <div className='d-flex align-items-center justify-content-between'>
          {/* Left Side: Text and Credit Info */}
          <div>
            <h3 className='mb-2'>Billing Alerts</h3>
            <div className='fs-6 text-gray-600 fw-bold mb-6'>
              Setup automated billing alerts to receive emails when a specified usage amount is
              reached.
            </div>

            {/* Metronics Style: Dashed Info Box */}
            <div className='d-flex align-items-center border border-dashed border-gray-300 rounded p-5 bg-light-primary'>
              <div className='d-flex flex-column me-5'>
                <span className='fs-6 fw-bold text-gray-800'>Current Credit Limit</span>
                <span className='fs-7 text-muted'>The threshold currently set on your account</span>
              </div>
              <div className='ms-auto'>
                <span className='fs-2x fw-bolder text-primary'>
                  {currencySymbol}
                  {currentCredit}
                </span>
              </div>
            </div>
          </div>

          {/* Right Side: Action Button */}
          {/* Added 'align-self-start' to keep button at top if the left content grows */}
          <button className='secondary-button align-self-start py-2' onClick={onAddAlert}>
            Add Alert
          </button>
        </div>
      </div>
    </div>
  )
}

export default BillingAlertsSection
